import type {AxiosError} from 'axios';
import {useMutation, type UseMutationOptions, type UseMutationResult} from 'react-query';
import {
	confirmLogin,
	type ConfirmLoginErrorResponse,
	type ConfirmLoginRequest,
	type ConfirmLoginResponse,
} from '../../http';

export function useConfirmLogin(
	options?: UseMutationOptions<ConfirmLoginResponse, AxiosError<ConfirmLoginErrorResponse>, ConfirmLoginRequest>,
): UseMutationResult<ConfirmLoginResponse, AxiosError<ConfirmLoginErrorResponse>, ConfirmLoginRequest> {
	return useMutation<ConfirmLoginResponse, AxiosError<ConfirmLoginErrorResponse>, ConfirmLoginRequest>(
		(request) => confirmLogin(request).then(({data}) => data),
		options,
	);
}
